import { render, staticRenderFns } from "./SocialNews.vue?vue&type=template&id=78e069ac&"
import script from "./SocialNews.vue?vue&type=script&lang=js&"
export * from "./SocialNews.vue?vue&type=script&lang=js&"
import style0 from "./SocialNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports